<div class="no-data-state">
    <div class="icon">📋</div>
    <h3>No Data Available</h3>
    <p>There is no data to display at the moment.</p>
</div>